const columns = [
    {
        title: 'Account Type',
        dataIndex: 'planName',
    },
    {
        title: 'Group Name',
        dataIndex: 'groupName',
    },
    {
        title: 'Maximun Commission ($)',
        dataIndex: 'maxCommission',
    },
    {
        title: 'Commision Amount ($)',
        dataIndex: 'commisionamount',
    },
];

export default columns;